import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import VideoPlayer from 'components/common/VideoPlayer';
import Image from 'components/common/utils/Image';
import cx from 'classnames';
import withCookies from 'react-cookie/cjs/withCookies';
import './styles.sass'
import { trackVideoPlayed } from 'utils/segment'

const IndexPage = (cookies, allCookies) => {
  const [showM6, setShowM6] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const videoUrl = "https://cdn.jwplayer.com/players/KQ33NDgw-KdT3I1iC.html"

  function m6Active() {
    if (sessionStorage.getItem('m6state') === 'true') return true;
    return sessionStorage.getItem('m6state') !== 'false';
  }

  function hideM6() {
    sessionStorage.setItem('m6state', 'false');
    setShowM6(false);
  }

  function showM6Modal() {
    trackVideoPlayed("Qui veut être mon associé", videoUrl)
    setShowModal(true)
  }

  useEffect(() => {
    if (m6Active === '') trackVideoPlayed("Qui veut être mon associé", videoUrl)
    setShowM6(m6Active);
  });

  return (
    <div className="m6-banner-wrapper">
      <div
        className={cx(
          "m6-banner",
          { "m6-banner-hidden": !showM6 },
          { "m6-banner-up": true }
        )}
      >
        <Image
          filename="new-images/qvema-2.jpg"
          className="m6-image-container"
          alt="Qui veut être mon associé"
          title="Qui veut être mon associé"
        />
        <div className="m6-banner-exit-cross-container">
          <Image
            onClick={hideM6}
            filename="new-images/cross-simple.svg"
            className="m6-banner-exit-cross"
            alt="icone croix"
          />
        </div>
        <div className="m6-text-container">
          <div className="m6-text">
            <div className="m6-text-sm">
              Découvrez nous sur
              {" "}<Image
                filename="new-images/logo/m6.png"
                className="m6-logo-inline img-fluid"
                alt="M6"
                title="logo m6"
              />
            </div>
            <div className="m6-text-md">
              Découvrez le passage de <span className="m6-charles">Charles.co</span> sur
              {" "}<Image
                filename="new-images/logo/m6.png"
                className="m6-logo-inline img-fluid"
                alt="M6"
                title="logo m6"
              />
            </div>
          </div>
          <div className="m6-cta" onClick={() => showM6Modal()}>
            <span>Voir le replay</span>
            <Image
              filename="new-images/arrow-link-white.svg"
              className="m6-replay-arrow"
              alt="fleche-droite-fine-picto"
              title="fleche droite fine picto"
            />
          </div>
        </div>
      </div>
      <Modal
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
      >
        <div className="expert-video-modal">
          <VideoPlayer video={videoUrl} />
        </div>
      </Modal>
    </div>
  );
};

export default withCookies(IndexPage);
